export default __webpack_public_path__ + "static/media/hero-mobile.80564771.png";